import { theme as _theme } from '@ballz-app/chakra';
import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme(_theme);
